import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { ConfirmModal } from 'components';

import useUsersCountQuery from './hooks/useUsersCountQuery';
import useNotifications from 'hooks/common/useNotifications';
import useDeletePartnerSchemeMutation from './hooks/useDeletePartnerSchemeMutation';

import { IDeleteSchemeModalProps } from './DeleteSchemeModal.types';

const { Text } = Typography;

const DeleteSchemeModal = ({ open, scheme, onFinish, onClose, ...props }: IDeleteSchemeModalProps) => {
  const { t } = useTranslation();
  const { notificationApi } = useNotifications();

  const { data, loading: fullLoading } = useUsersCountQuery({ refetchOnMount: open, id: scheme?.id });
  const { loading: deleteLoading, refetch: deletePartnerScheme } = useDeletePartnerSchemeMutation();

  const onDeleteScheme = async (id: number) => {
    const { success, errorMessage } = await deletePartnerScheme(id);

    if (success) {
      notificationApi.success({ title: t('success.deletePartnerScheme') });
      onFinish();
    } else {
      notificationApi.error({ title: t(errorMessage) });
    }

    onClose();
  };

  return (
    <ConfirmModal
      title={t('modal.partnerSchemes.deleteScheme.title')}
      open={open}
      width={450}
      loading={deleteLoading}
      fullLoading={fullLoading}
      onAgree={() => onDeleteScheme(scheme.id)}
      onClose={onClose}
      {...props}
    >
      <Text>
        {t('modal.partnerSchemes.deleteScheme.desc', { name: scheme?.name, interpolation: { escapeValue: false } })}
      </Text>

      {data && !fullLoading ? (
        <Alert showIcon type="warning" title={t('modal.partnerSchemes.deleteScheme.warning', { count: data })} />
      ) : null}
    </ConfirmModal>
  );
};

export default DeleteSchemeModal;
